import React, { useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './EllipsisToolTip.scss';
import { compose } from 'redux';
import { IS_MOBILE } from 'Constants/device.APP_TARGET';
import { DATA_AUT_IDS, ROLES } from 'Constants/constants';
import withConfig from 'HOCs/withConfig/withConfig';
import { CONFIG } from 'Constants/config';

export const EllipsisToolTip = ({ children, tooltip, tooltipText, config, tooltipClass }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [show, setShow] = useState(false);
    const showModernDesign = config.get(CONFIG.SHOW_MODERN_DESIGN);
    const ref = useRef(null);

    useEffect(() => {
        if (ref?.current) {
            setIsOverflowing(ref.current.offsetWidth < ref.current.scrollWidth);
        }
    }, [show]);

    const handleShow = useCallback(() => setShow(true), []);
    const handleHide = useCallback(() => setShow(false), []);

    return (
        <span>
            <div
                data-aut-id={ DATA_AUT_IDS.ELLIPSES }
                ref={ ref }
                onMouseOver={ tooltip ? handleShow : null }
                onMouseOut={ tooltip ? handleHide : null }
                className={ css.ellipsis }
            >
                {children}
            </div>
            {tooltip && show && isOverflowing && !IS_MOBILE && (
                <span
                    role={ ROLES.TOOLTIP }
                    data-aut-id={ DATA_AUT_IDS.TOOLTIP }
                    data-tooltip={ tooltipText }
                    className={ classNames(css.tooltip, tooltipClass, {
                        [css.showTooltip]: show,
                        [css.tooltipLetgo]: showModernDesign
                    }) }
                />
            )}
        </span>
    );
};

EllipsisToolTip.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    tooltip: PropTypes.bool,
    tooltipText: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }),
    tooltipClass: PropTypes.string
};

EllipsisToolTip.defaultProps = {
    tooltip: false
};

export default compose(
    withConfig
)(EllipsisToolTip);
